import React from 'react';

import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';
import { toogleHeaderRequiredField } from 'store/actions';

import { Header } from 'components';

const HeaderContainer = props => <Header {...props} />;
const mapStateToProps = (state) => {
  const reservationCode = fromReservation.getReservationCode(state);
  const requiredInputFields = fromReservation.getRequiredInputFields(state);
  const validationErrors = fromReservation.getValidationErrors(state);
  const saveStatus = fromReservation.getSaveStatus(state);
  const headerRequiredFieldToggle = fromReservation.getHeaderRequiredFieldToggle(state);
  const numberOfVisaRequired = fromReservation.getNumberOfVisaRequired(state);
  const cabinsAllocated = fromReservation.isCabinsAllocated(state, fromReservation.getActiveDepartureId(state));
  const checkinStarted = fromReservation.isCheckInStarted(state, fromReservation.getActiveDepartureId(state));
  const activeDepartureId = fromReservation.getActiveDepartureId(state);
  const languageCode = fromReservation.getLanguageCode(state);

  return {
    reservationCode,
    numberOfVisaRequired,
    requiredInputFields,
    validationErrors,
    saveStatus,
    headerRequiredFieldToggle,
    cabinsAllocated,
    checkinStarted,
    activeDepartureId,
    languageCode,
  };
};

const getOutOrHome = (titleRow) => {
  const outTop = titleRow[0] && titleRow[0].offsetTop;
  const homeTop = titleRow[1] && titleRow[1].offsetTop;
  if (homeTop > outTop) {
    return 'home';
  }
  return 'out';
};

const getHeaderOffsetTop = (titleRow) => {
  if (getOutOrHome(titleRow) === 'home') {
    return titleRow[1].offsetTop;
  }
  return titleRow[0] && titleRow[0].offsetTop;
};

const stickyHeader = () => {
  let titleRowTop = null;
  window.onscroll = () => {
    const saveAndErrorArea = document.getElementById('save-and-error-area');
    const cabinButton = document.querySelectorAll('.manage-all-cabins-button');
    const departureTitle = document.querySelectorAll('.glow-heading');
    const titleRow = document.querySelectorAll('.table-header');

    const titleRowOut = titleRow[0];
    const titleRowHome = titleRow[1];
    const cabinButtonOutTop = cabinButton[0];
    const cabinButtonOutHome = cabinButton[1];
    const departureTitleOut = departureTitle[0];
    const departureTitleHome = departureTitle[1];

    titleRowTop = getHeaderOffsetTop(titleRow);

    if (window.pageYOffset >= titleRowTop) {
      if (getOutOrHome(titleRow) === 'home') {
        titleRowHome && titleRowHome.classList.add('sticky');
        cabinButtonOutHome && cabinButtonOutHome.classList.add('sticky');
        departureTitleHome && departureTitleHome.classList.add('sticky');
      } else {
        titleRowOut && titleRowOut.classList.add('sticky');
        cabinButtonOutTop && cabinButtonOutTop.classList.add('sticky');
        departureTitleOut && departureTitleOut.classList.add('sticky');
      }

      saveAndErrorArea && saveAndErrorArea.classList.add('sticky');
    } else {
      if (getOutOrHome(titleRow) === 'home') {
        titleRowHome && titleRowHome.classList.remove('sticky');
        cabinButtonOutHome && cabinButtonOutHome.classList.remove('sticky');
        departureTitleHome && departureTitleHome.classList.remove('sticky');
      } else {
        titleRowOut && titleRowOut.classList.remove('sticky');
        cabinButtonOutTop && cabinButtonOutTop.classList.remove('sticky');
        departureTitleOut && departureTitleOut.classList.remove('sticky');
      }

      saveAndErrorArea && saveAndErrorArea.classList.remove('sticky');
    }
  };
};

const mapDispatchToProps = dispatch => ({
  onRequiredFieldToggleExpanded: () => dispatch(toogleHeaderRequiredField()),
  stickHeader: () => stickyHeader(),
});


export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/Header.js